import React, { useEffect, useState } from 'react'
import {
    PieChart,
    Pie,
    Cell,
    ResponsiveContainer,
} from "recharts";
import { toWords } from "number-to-words";
import EmiSchedule from './EmiSchedule';
import './calculator.css';


const Calculator = () => {
    const [loanAmount, setLoanAmount] = useState(1000000);
    const [tenure, setTenure] = useState(20);
    const [rate, setRate] = useState(6.5);

    const [emi, setEmi] = useState(0);
    const [totalInterest, setTotalInterest] = useState(0);
    const [totalPayable, setTotalPayable] = useState(0);

    const [schedule, setSchedule] = useState([]);
    const [showSchedule, setShowSchedule] = useState(true);

    useEffect(() => {
        calculateEMIHome();
    }, [loanAmount, tenure, rate]);

    const calculateEMIHome = () => {
        const P = loanAmount;
        const r = rate / 12 / 100;
        const n = tenure * 12;

        const emiVal =
            (P * r * Math.pow(1 + r, n)) / (Math.pow(1 + r, n) - 1);

        const total = emiVal * n;
        const interest = total - P;

        setEmi(emiVal);
        setTotalInterest(interest);
        setTotalPayable(total);
    };

    const COLORS = ["#111827", "#1a237e"]; // Principal, Interest

    const paymentData = [
        { name: "Principal", value: loanAmount },
        { name: "Interest", value: totalInterest },
    ];

    const NumberToText = (amount) => {
        console.log("amount", amount);
        if (!amount || amount <= 0) return <p>N/A</p>;
        return (
            <p>
                {toWords(amount)
                    .replace(/\b\w/g, c => c.toUpperCase())}
            </p>
        );
    };

    const [isOpen, setIsOpen] = useState(false);

    const toggleSchedule = () => {
        setIsOpen(!isOpen);
    };

    return (
        <>
            <div className="calculator-card">
                <div>
                    <label>Loan Amount <span>₹{loanAmount.toLocaleString()}</span></label>
                    <input
                        type="range"
                        min="500000"
                        max="20000000"
                        step="50000"
                        value={loanAmount}
                        onChange={(e) => setLoanAmount(+e.target.value)}
                    />
                    <div className='text-under-range'>
                        <p>5 Lac</p>
                        <p>20 Cr</p>
                    </div>

                    <label>Loan Tenure <span>{tenure} Years</span></label>
                    <input
                        type="range"
                        min="5"
                        max="30"
                        value={tenure}
                        onChange={(e) => setTenure(+e.target.value)}
                    />
                    <div className='text-under-range'>
                        <p>5</p>
                        <p>30</p>
                    </div>

                    <label>Rate of Interest <span>{rate}%</span></label>
                    <input
                        type="range"
                        min="6"
                        max="20"
                        step="0.1"
                        value={rate}
                        onChange={(e) => setRate(+e.target.value)}
                    />
                    <div className='text-under-range'>
                        <p>5</p>
                        <p>20</p>
                    </div>
                </div>

                {/* EMI Box */}
                <div className="emi-box">
                    <p>Monthly Loan EMI</p>
                    <h2>₹{emi.toFixed(0)}</h2>
                    <p>{NumberToText(emi.toFixed(0))}</p>
                </div>

                {/* Payment Breakdown */}
                <div className="breakdown-box">
                    <h4>Payment Breakdown</h4>

                    {/* Chart */}
                    <div className="chart-wrapper">
                        <ResponsiveContainer width={220} height={180}>
                            <PieChart>
                                <Pie
                                    data={paymentData}
                                    dataKey="value"
                                    innerRadius={40}
                                    outerRadius={80}
                                >
                                    {paymentData.map((_, index) => (
                                        <Cell key={index} fill={COLORS[index]} />
                                    ))}
                                </Pie>
                            </PieChart>
                        </ResponsiveContainer>
                    </div>

                    {/* Legend + Values */}
                    <p>
                        <span>
                            <span className="legend principal"></span>
                            Principal Amount
                        </span>
                        <span>
                            ₹{loanAmount.toLocaleString()}
                        </span>
                    </p>
                    <p>
                        <span>
                            <span className="legend interest"></span>
                            Interest Payable
                        </span>
                        <span>
                            ₹{totalInterest.toFixed(0)}
                        </span>
                    </p>
                    <p className="total-payable">
                        <span>
                            Total Amount Payable:
                        </span>
                        <span>
                            ₹{totalPayable.toFixed(0)}</span>
                    </p>
                    <button
                        onClick={toggleSchedule}
                        className="toggle-button"
                    >
                        {isOpen ? "Hide EMI Schedule" : "Show EMI Schedule"}
                    </button>
                </div>
            </div>

            <div className="emi-wrapper">
                <div
                    className={`emi-content ${isOpen ? "open" : "collapsed"}`}
                    style={{
                        // maxHeight: isOpen ? "1000px" : "0px",
                        overflow: "hidden",
                        transition: "max-height 0.5s ease",
                    }}
                >
                    <EmiSchedule loanAmount={loanAmount} rate={rate} tenure={tenure} />
                </div>
            </div>
        </>
    )
}

export default Calculator